module.exports = __webpack_public_path__ + "static/media/6_fixed.2382c83c.jpg";